import { useQuery } from 'hooks/useCustomQuery';
import getCompanyServicesWithSRT from 'API/SRT/getCompanyServicesWithSRT';
import getService from 'API/Service/getService';
import { SBC } from 'pages/dashboards/v5/constants';

/**
 * The company's SBCaaS (Classic) service, for the regions and channel ceiling
 * its trunks are constrained by.
 *
 * Mirrors `useGetSRTTrunkService`, which does the same for the modern service.
 *
 * @param {object}   params
 * @param {string}   params.companyID
 * @param {function} params.onSuccess Receives `{ regions, maxChannel }`.
 */
const useGetSbcaasTrunkService = ({ companyID, onSuccess }) =>
    useQuery({
        queryKey: ['sbcaasTrunkService', companyID],
        queryFn: async () => {
            const servicesRes = await getCompanyServicesWithSRT(companyID);
            const sbcaasService = servicesRes.data.find(
                ({ serviceType }) => serviceType === SBC,
            );
            if (!sbcaasService?.id) return { regions: [], maxChannel: 0 };

            const serviceRes = await getService(sbcaasService.id);
            return {
                regions: serviceRes.data.regions || [],
                maxChannel: serviceRes.data.maxChannel || 0,
            };
        },
        enabled: Boolean(companyID),
        onSuccess,
    });

export default useGetSbcaasTrunkService;
